<template>
  <div class="flex flex-col w-full h-full overflow-hidden">
    <div
      class="flex items-center justify-center w-full py-4 max-large-desktop:hidden"
    >
      <ChatOnlineUsers />
    </div>
    <button
      class="p-2 rounded-lg bg-fill-brand-secondary w-full text-start flex flex-row justify-start items-center gap-1 min-h-12"
      @click="emit('close')"
    >
      <Icon
        icon="weui:arrow-outlined"
        class="text-lg size-6 text-icon shrink-0 rotate-180"
      />
      <span class="text-text font-sans text-sm font-semibold leading-5">
        # {{ chat.chatRoomTitle }}
      </span>
    </button>

    <Chat
      class="flex-1 min-h-0 flex rounded-lg w-full !px-0 [&_>_[data-message-container]]:!mt-0 desktop:!max-w-full"
      :allow-questions="false"
      :load-messages-on-mount="true"
      @send-message="sendChatMessage"
      @message-like="likeChatMessage"
    />
  </div>
</template>

<script setup lang="ts">
import { watch } from "vue";
import Chat from "./chat.vue";
import { useChat } from "@/stores/chat/services/use-chat";
import { useChatStore } from "@/stores/chat/chat.store";
import ChatOnlineUsers from "../chat-online-users.vue";
import { Icon } from "@iconify/vue";
import { useAuthForAction } from "@/composables/global/use-auth-for-action";

const props = defineProps<{
  chatRoomId: string;
}>();

const emit = defineEmits<{
  close: [];
}>();

const chat = useChat();
const sendChatMessage = useAuthForAction(
  (message: string, isQuestion: boolean, replyToId: string | null) => {
    chat.sendChatMessage(message, isQuestion, replyToId);
  },
);

const likeChatMessage = useAuthForAction(
  (messageId: string, isLiked: boolean) => {
    chat.likeChatMessage(messageId, isLiked);
  },
);

const chatStore = useChatStore();

watch(
  () => chat.lastVerifiedMessage,
  (value) => {
    if (value === null) return;

    const chatRoomId = props.chatRoomId;
    const chatRoom = chatStore.chatRooms.get(chatRoomId);
    if (!chatRoom) return;
    chatStore.chatRooms.get(chatRoomId)!.lastSeenMessageId = value.id;
  },
);
</script>
